import { useConfig } from "../../../contexts/ConfigContext"
import { useSale } from "../../../contexts/SaleContext"
import React, { useEffect, useState } from "react"
import { Dropdown, Popconfirm, TableColumnsType, Input, Select, Tag } from "antd"
import { mutate } from "swr"
import { contentLayout, contentPath, modules, saleStatus } from "../../../config/const"
import TableView from "../TableView"
import { useCompany } from "../../../contexts/CompanyContext"
import useAuth from "../../../hooks/useAuth"
import { useSales } from "../../../hooks/useSale"
import { MoreOutlined } from "@ant-design/icons"
import { textNumberFormater } from "../../../utils"
import { useHistory } from "react-router-dom"
import { useSecureRequest } from "../../../hooks/useSecureRequest"

function ViewPendingSale(){
  const history = useHistory()
  const { config,updateConfig } = useConfig()
  const { sale, updateSale} = useSale()
  const {company} = useCompany()
  const [spinning, setSpinning] = useState(false)
  const [skeleton, setSkeleton] = useState(true)
  const [searchFilter, setSearchFilter] = useState("")
  const [originFilter, setOriginFilter] = useState("ALL")
  const { securePost } = useSecureRequest()
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:saleData} = useSales(tokenData,{
    company:company.current.uid,
    status:saleStatus.PENDING,
    documentType: "SALE_INVOICE",
    pending: true,
    module: config.module
  },company.current.id)
  useEffect(()=>{
    if(tokenData && saleData?.movementList){
      updateSale({pendingList:saleData.movementList})
      setSkeleton(false)
    }

  },[tokenData,saleData])

  let title = 'Ventas pendientes por facturar'
  let emptyMessage = 'Aun no hay registros pendientes por facturar'
  
  const handleClick = async (data:any) => {
    console.log("Click sobre item: ",data)
    setSpinning(true)
    const saleResponse = await securePost('/inventory/movement/get-movement',{
      company: company.current.uid,
      uidMovement: data.uid,
      module: config.module
    })
    setSpinning(false)
    if(saleResponse.status === 200){
      if (saleResponse.movement?.client_verification_required || saleResponse.movement?.contact_status === 'UNVERIFIED_NEW') {
        alert("Atención: Este pedido proviene de la Tienda Online con un cliente por verificar. Valide los datos de contacto y documento con el comprador antes de emitir la factura.")
      }
      updateSale({item_list: saleResponse.movement.item_list,currentPending:saleResponse.movement})
      updateConfig({forceModule:true,module:modules.RegisterSale,content:contentLayout[modules.RegisterSale]})
      history.push(contentPath[modules.RegisterSale])
    }else{
      alert("Ha ocurrido un error, por favor recargue la página e intente de nuevo")
    }
  }

  const menuItems = (record:any) => [
    {
      key: "1",
      label: (<button className="link-button" onClick={() => handleClick(record)}>Retomar venta</button>),
    },
    {
      key: "2",
      label: (
        <Popconfirm title="¡Esta seguro que desea eliminar este elemento?" onConfirm={() => deleteItem(record.uid)}>
          <span>Eliminar</span>
        </Popconfirm>
      ),
    },
  ];
  //Solo debe existir en firestore al ser un PENDING
  //Por lo tanto la actualización solo aplica en Firestore
  async function deleteItem(uid:string){
    setSpinning(true)
    const companyUid = company.current.uid
    if(companyUid && uid){
      const newPendinglist = sale.pendingList.filter(val => val.uid !== uid)
      await securePost("/inventory/movement/update-movement",{
        company:companyUid,
        uidMovement:uid,
        movement:{
          status: saleStatus.CANCELLED
        },
        module: config.module
      })
      updateSale({pendingList:newPendinglist})
      if(sale.currentPending?.uid === uid){
        updateSale({currentPending:null, item_list: []})
      }
      void mutate(
        key => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement'),
        undefined,
        { revalidate: true }
      )
    }
    setSpinning(false)
  }
  const rowMenu = (record:any) => {
    if(typeof record.key === "string" && !record.uid){
      return(<></>)
    }else{
      return(
        <Dropdown menu={{items:menuItems(record)}} trigger={['click']}>
          <button className="link-button" style={{ display: "block",width:"100%", justifyContent: "center",cursor:"pointer" }} onClick={(e) => e.stopPropagation()}>
            <MoreOutlined
              style={{ fontSize: "18px", cursor: "pointer" }}
            />
          </button>
        </Dropdown>
      )
    }
  }

  const tableColumns:TableColumnsType = [
    {title: "#",dataIndex:"register"},
    {
      title: "Registro",
      dataIndex:"document_number",
      render: (docNum: string, record: any) => (
        <div>
          <span style={{ fontWeight: 600 }}>{docNum || record.uid}</span>
          {record.origin_channel === 'ECOMMERCE' || docNum?.startsWith('WEB-') ? (
            <div style={{ marginTop: 2 }}>
              <Tag color="blue">Tienda Online</Tag>
              {(record.client_verification_required || record.contact_status === 'UNVERIFIED_NEW') && (
                <Tag color="warning">Contacto por Validar</Tag>
              )}
            </div>
          ) : (
            <div style={{ marginTop: 2 }}>
              <Tag color="default">Mostrador</Tag>
            </div>
          )}
        </div>
      )
    },
    {title: "Items",dataIndex:"items"},
    {title: "Ultima modificación",dataIndex:"updated_at",render:(text)=>new Date(text).toLocaleString()},
    {title: "Total",dataIndex:"total_amount",render:(text)=><label className="numeric-values-data-table">{textNumberFormater(text)}</label>},
    {title:"Acciones",key:"actions",render:(_, record) => rowMenu(record)}
  ]

  const filteredList = (sale?.pendingList || []).filter((el: any) => {
    const docNumber = (el.document_number || el.uid || "").toLowerCase()
    const matchesSearch = !searchFilter || docNumber.includes(searchFilter.toLowerCase())
    const isEcommerce = el.origin_channel === 'ECOMMERCE' || (el.document_number || "").startsWith('WEB-')
    const matchesOrigin = originFilter === "ALL" || 
      (originFilter === "ECOMMERCE" && isEcommerce) ||
      (originFilter === "INTERNAL" && !isEcommerce)
    return matchesSearch && matchesOrigin
  })

  const dataTable = filteredList.map((el:any,i:number)=>{
    el.register = i + 1
    el.key = el.uid || i  
    return el
  })

  const headerElement = () => (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <Input.Search
        placeholder="Buscar registro (ej. WEB-1234)..."
        allowClear
        value={searchFilter}
        onChange={e => setSearchFilter(e.target.value)}
        style={{ width: 220 }}
      />
      <Select 
        value={originFilter} 
        onChange={setOriginFilter} 
        style={{ width: 140 }}
        options={[
          { label: "Todos los orígenes", value: "ALL" },
          { label: "Tienda Online", value: "ECOMMERCE" },
          { label: "Mostrador", value: "INTERNAL" }
        ]}
      />
    </div>
  )
  
  return (
    <TableView
      title={title}
      spinning={spinning}
      skeleton={skeleton}
      tableColumns={tableColumns}
      dataTable={dataTable}
      onRow={() => {}}
      emptyMessage={emptyMessage}
      headerElement={headerElement}>
    </TableView>
  )
}

export default ViewPendingSale
